<template>
  <div>
    <div class="page-title">Edit Registration Form</div>
    <Form
      v-if="form"
      v-model="form"
      :submit="update"
      btnText="Update Registration Form"
    />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.registration-forms.page";
export default {
  components: { Form },
  metaInfo() {
    const subject = this.form?.title;
    return {
      title: subject
        ? `Edit “${subject}” Registration Form`
        : `Edit Registration Form`,
    };
  },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.RegistrationForm.get({
        id: this.$route.params.id,
      });
      this.form = data;
    },
    async update() {
      await this.$api.RegistrationForm.update(this.form);
      this.$router.push("/widgets/registration-forms");
    },
  },
};
</script>

<style></style>
